// frontend/src/components/auth/AuthExpiredModal.js
import React, { useState, useEffect } from "react";
import authService from "../../services/authService";
import { toast } from "react-toastify";

const AuthExpiredModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Reset the global flag when this component mounts
    window.isAuthModalOpen = false;

    const handleTokenExpired = () => {
      setIsOpen(true);
      toast.warning("Your session has expired. Please log in again.", {
        position: "top-right",
        autoClose: 5000,
      });
    };
    // 👇 ADD THIS: Force-close the modal when the user logs out
    const handleLoggedOut = () => {
      setIsOpen(false);
      window.isAuthModalOpen = false;
    };
    window.addEventListener("auth:token-expired", handleTokenExpired);
    window.addEventListener("auth:logged-out", handleLoggedOut); // 👈 ADD THIS
    return () => {
      window.removeEventListener("auth:token-expired", handleTokenExpired);
      window.removeEventListener("auth:logged-out", handleLoggedOut); // 👈 ADD THIS
    };
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    window.isAuthModalOpen = false; // Reset global flag
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await authService.login(email, password);
      
      console.log("🔍 Login Response Data:", data);

      // Handle both common token names
      const accessToken = data.accessToken || data.token;
      const refreshToken = data.refreshToken;
      const user = data.user || data.data?.user;

      if (!accessToken) {
        throw new Error("No access token received from server");
      }

      // Save to localStorage with the correct keys
      localStorage.setItem("accessToken", accessToken);
      if (refreshToken) {
        localStorage.setItem("refreshToken", refreshToken);
      }
      if (user) {
        localStorage.setItem("user", JSON.stringify(user));
      }

      setIsOpen(false);
      window.isAuthModalOpen = false;
      
      toast.success("Logged in successfully!");
      window.location.reload(); 
      
    } catch (err) {
      console.error("❌ Login Error:", err);
      toast.error(err.message || err.error || "Login failed. Please check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <button onClick={handleClose} style={styles.closeButton}>✕</button>
        <h2 style={{ marginTop: 0 }}>Session Expired</h2>
        <p style={{ color: "#666", fontSize: "14px" }}>
          Please log in again to continue where you left off.
        </p>
        <form onSubmit={handleLogin} style={styles.form}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={styles.input}
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={styles.input}
          />
          <button type="submit" disabled={loading} style={styles.button}>
            {loading ? "Logging in..." : "Log In"}
          </button>
        </form>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: "rgba(0,0,0,0.5)", display: "flex",
    justifyContent: "center", alignItems: "center", zIndex: 9999,
  },
  modal: {
    backgroundColor: "#fff", padding: "30px", borderRadius: "8px",
    width: "400px", maxWidth: "90%", boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    position: "relative",
  },
  closeButton: {
    position: "absolute", top: "10px", right: "15px",
    background: "none", border: "none", fontSize: "18px",
    cursor: "pointer", color: "#999",
  },
  form: { display: "flex", flexDirection: "column", gap: "15px", marginTop: "20px" },
  input: { padding: "10px", borderRadius: "4px", border: "1px solid #ccc", fontSize: "14px" },
  button: {
    padding: "10px", backgroundColor: "#007bff", color: "#fff",
    border: "none", borderRadius: "4px", cursor: "pointer", fontSize: "16px",
  },
};

export default AuthExpiredModal;